import React, { Component } from "react";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import EditSponsorBlockDialog from "../../components/settings/EditSponsorBlockDialog";

class EditSponsorBlockContainer extends Component {
  state = {
    open: false,
    name: "",
  };

  toggleDialog = () => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      this.setState({ open: !this.state.open });
    }
  };

  UNSAFE_componentWillMount = () => {
    if (this.props.sponsorBlockName) {
      this.setState({ name: this.props.sponsorBlockName });
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const sponsorBlockName = nextProps.sponsorBlockName;
    if (sponsorBlockName) {
      this.setState({ name: sponsorBlockName });
    }
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    this.setState(newState);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.toggleDialog();
    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    let sponsorBlockNames = this.props.tournament.sponsorBlockNames || {};
    sponsorBlockNames[this.props.blockNum] = this.state.name;
    tournamentRef.update({ sponsorBlockNames: sponsorBlockNames });
  };

  render() {
    return (
      <div>
        <IconButton
          aria-label="Change"
          onClick={this.toggleDialog}
          style={{
            height: 20,
            width: 20,
            color: "white",
            marginRight: 5,
          }}
        >
          <CreateIcon
            style={{ height: 20, width: 20, position: "absolute", top: 2 }}
          />
        </IconButton>
        <EditSponsorBlockDialog
          name={this.state.name}
          open={this.state.open}
          toggleDialog={this.toggleDialog}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
        />
      </div>
    );
  }
}

export default EditSponsorBlockContainer;
